import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CircleRadiusSizes, CircleSizes, CircleVariants, } from "./constants";
import { Contrast, } from "../../../../components/types/general.types";
import { IconSizes, IconVariants } from "../../Images/Icon/constants";
import { StyledCircle, StyledCircleRing, StyledCircleSpin, StyledCircleSvg, StyledIcon, } from "./Circle.style";
import { useEffect, useState } from "react";
import { Icon } from "../../Images";
const Circle = ({ size = CircleSizes.medium, variant = CircleVariants.primary, contrast = Contrast.default, iconName = "", active = true, animation, ...props }) => {
    const circleRadius = CircleRadiusSizes[size];
    const [circleClassName, setCircleClassName] = useState("hide");
    const [showCircle, setShowCircle] = useState(false);
    useEffect(() => {
        let circleTimeout;
        if (active) {
            setShowCircle(true);
            setTimeout(() => {
                setCircleClassName("show");
            }, 1);
        }
        else {
            setCircleClassName("hide");
            circleTimeout = setTimeout(() => {
                setShowCircle(false);
            }, 2000);
        }
        return () => {
            clearTimeout(circleTimeout);
        };
    }, [active]);
    const getIconProps = (variant, size, contrast) => {
        const iconProps = {
            size: size === CircleSizes.xlarge
                ? IconSizes.xlarge
                : size === CircleSizes.large
                    ? IconSizes.medium
                    : IconSizes.small,
            contrast: contrast,
        };
        switch (variant) {
            case CircleVariants.primary: {
                return { ...iconProps, variant: IconVariants.primary };
            }
            case CircleVariants.secondary: {
                return { ...iconProps, variant: IconVariants.secondary };
            }
        }
    };
    return (_jsx(_Fragment, { children: showCircle && (_jsxs(StyledCircle, { className: circleClassName, size: size, variant: variant, contrast: contrast, animation: animation, ...props, children: [_jsxs(StyledCircleSvg, { xmlns: "http://www.w3.org/2000/svg", role: "img", size: size, variant: variant, contrast: contrast, ...props, children: [_jsx(StyledCircleRing, { cx: circleRadius, cy: circleRadius, r: circleRadius, size: size, variant: variant, contrast: contrast, ...props }), _jsx(StyledCircleSpin, { cx: circleRadius, cy: circleRadius, r: circleRadius, size: size, variant: variant, contrast: contrast, ...props })] }), _jsx(StyledIcon, { children: iconName &&
                        size !== CircleSizes.tiny &&
                        size !== CircleSizes.small && (_jsx(Icon, { name: iconName, ...getIconProps(variant, size, contrast) })) })] })) }));
};
export default Circle;
//# sourceMappingURL=Circle.js.map